import { on } from '@/utils/dom'
import store from '@/store/store'
import { Message } from 't-tyui'
function createDom(el) {

  el.style.position = 'relative'
  el.classList.add('is-disabled')
  el.setAttribute('disabled', 'disabled')

  const div = document.createElement('div')
  const style = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 9,
    cursor: 'no-drop'
  }
  for (const key in style) {
    div.style[key] = style[key]
  }
  div.setAttribute('title', '权益已到期')
  div.onclick = function (e) {
    const event = e || window.event
    event.preventDefault()
    event.stopPropagation()
    Message({ message: '权益已到期', type: 'warning' })
  }
  el.appendChild(div)

  el._$authTip = true
}
const interestExpire = {
  /**
   * binding.value
   * function || options({handler})
   * options
   */
  bind(el, binding, vnode) {
    if (!el) return
    if (store.state.someInterest?.statisticsData?.companyInterestExpireFlag) {
      vnode.componentInstance && vnode.componentInstance.$off('click')
      createDom(el)
    }
  },

  update(el, binding, vnode) {
    if (store.state.someInterest?.statisticsData?.companyInterestExpireFlag && !el._$authTip) {
      vnode.componentInstance && vnode.componentInstance.$off('click')
      createDom(el)
    }
  },
  componentUpdated(el, binding, vnode) {
    if (store.state.someInterest?.statisticsData?.companyInterestExpireFlag && !el._$authTip) {
      vnode.componentInstance && vnode.componentInstance.$off('click')
      createDom(el)
    }
  }
}

export default { interestExpire }
